export const CARE_PROFILE_PLAN_FEATURE_KEYS = {
	pro: [
		'CareProfile/PlanCard/Feat/Glp1Doctors',
		'CareProfile/PlanCard/Feat/DoctorResponse4h',
		'CareProfile/PlanCard/Feat/VideoDoctor1x',
		'CareProfile/PlanCard/Feat/VideoCoach1x',
		'CareProfile/PlanCard/Feat/Webinars',
		'CareProfile/PlanCard/Feat/OtcDiscount',
	],
	max: [
		'CareProfile/PlanCard/Feat/Glp1Doctors',
		'CareProfile/PlanCard/Feat/DoctorResponse4h',
		'CareProfile/PlanCard/Feat/VideoDoctor3x',
		'CareProfile/PlanCard/Feat/VideoCoach2x',
		'CareProfile/PlanCard/Feat/Webinars',
		'CareProfile/PlanCard/Feat/OtcDiscount',
	],
} as const;

export type CareProfilePlanCardTier = keyof typeof CARE_PROFILE_PLAN_FEATURE_KEYS;

export const isCareProfilePlanCardTier = (tier: string): tier is CareProfilePlanCardTier =>
	tier === 'pro' || tier === 'max';
